module.exports = __webpack_public_path__ + "img/icon_circlenodoctor.fb60789a.svg";